import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首頁", path: "/" },
  { label: "品牌故事", path: "/brand-story" },
  { label: "產品介紹", path: "/products" },
  { label: "最新消息", path: "/news" },
  { label: "職人日誌", path: "/craft-diary" },
  { label: "電商 / 禮盒", path: "/gift-box" },
  { label: "加盟專區", path: "/franchise" },
  { label: "聯絡我們", path: "/contact" },
];

const serviceLinks = [
  "現烤紅豆餅",
  "冷凍宅配",
  "禮盒團購",
  "企業下午茶",
  "市集活動",
  "加盟創業",
];

export default function Footer() {
  return (
    <footer className="bg-redbean-coffee text-redbean-cream">
      <div
        className="mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16"
        style={{ maxWidth: "1200px" }}
      >
        {/* Top Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/eff900376d0ae7cc09521c15ed9fd91b.png"
                  alt="來加綉綉紅豆餅品牌標誌"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-heading font-bold text-lg">
                來加綉綉紅豆餅
              </span>
            </div>
            <p className="text-redbean-cream/70 text-[1rem] leading-relaxed">
              來加綉綉紅豆餅，以手作餅皮、厚實內餡與現烤香氣，打造有溫度的台灣紅豆餅品牌。提供產品訂購、冷凍宅配、禮盒團購與加盟合作諮詢。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-[1.125rem] mb-3 pb-2 border-b border-redbean-primary/40">
              快速連結
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-redbean-cream/70 text-[1rem] hover:text-redbean-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-[1.125rem] mb-3 pb-2 border-b border-redbean-primary/40">
              服務項目
            </h4>
            <ul className="space-y-2">
              {serviceLinks.map((item) => (
                <li key={item}>
                  <span className="text-redbean-cream/70 text-[1rem]">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-[1.125rem] mb-3 pb-2 border-b border-redbean-primary/40">
              聯絡資訊
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5 text-redbean-cream/70 text-[1rem]">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-chat-3-line" />
                </span>
                <span>LINE@：@214epvsm</span>
              </li>
              <li className="flex items-start gap-2.5 text-redbean-cream/70 text-[1rem]">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line" />
                </span>
                <span>電話：請填入</span>
              </li>
              <li className="flex items-start gap-2.5 text-redbean-cream/70 text-[1rem]">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line" />
                </span>
                <span>Email：請填入</span>
              </li>
              <li className="flex items-start gap-2.5 text-redbean-cream/70 text-[1rem]">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line" />
                </span>
                <span>地址：請填入</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-10 md:mt-12 pt-8 border-t border-redbean-cream/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            {/* Big Brand Text */}
            <div className="text-center sm:text-left">
              <span className="font-heading font-black text-[3rem] md:text-[4rem] text-redbean-primary leading-none">
                綉綉
              </span>
              <div className="mt-2 flex items-center gap-3">
                <div className="w-8 h-px bg-redbean-cream/20" />
                <span className="text-redbean-cream/50 text-sm">
                  © 來加綉綉紅豆餅 All Rights Reserved.
                </span>
              </div>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-4">
              <a
                href="#"
                rel="nofollow"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-redbean-cream/10 text-redbean-cream/70 hover:bg-redbean-gold hover:text-redbean-coffee transition-colors cursor-pointer"
                aria-label="Instagram"
                onClick={(e) => { e.preventDefault(); }}
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="#"
                rel="nofollow"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-redbean-cream/10 text-redbean-cream/70 hover:bg-redbean-gold hover:text-redbean-coffee transition-colors cursor-pointer"
                aria-label="Facebook"
                onClick={(e) => { e.preventDefault(); }}
              >
                <i className="ri-facebook-fill text-lg" />
              </a>
              <a
                href="https://lin.ee/xiNNjjf"
                rel="nofollow"
                target="_blank"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-redbean-cream/10 text-redbean-cream/70 hover:bg-redbean-gold hover:text-redbean-coffee transition-colors cursor-pointer"
                aria-label="LINE"
              >
                <i className="ri-chat-3-line text-lg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}